import { SubmissionError } from "redux-form";

import { Snackbar } from "@js/components/snackbar";
import { typeGuard } from "@js/utils";
import { formatErrorForSnackbar } from "@js/utils/string";

const handleFormError = (data: Record<string, string> | undefined) => {
  if (!data) return;

  if (data?.code || data?.code_is_required || data?.company_node) {
    throw new SubmissionError(data);
  }
};

export const handleResponseError = (
  error: Record<string, unknown>,
  errorMsg = "Sorry! An unexpected error occurred",
) => {
  if (!error) return;
  const data = typeGuard<unknown, { data: Record<string, string> }>(
    error.response,
    "data",
  )
    ? error.response.data
    : undefined;
  handleFormError(data);
  Snackbar.error(data?._error || formatErrorForSnackbar(data) || errorMsg, {
    autoHideDuration: 10000,
  });
};
